import { Download } from "lucide-react";
import { toast } from "sonner";
import { downloadFile } from "../../lib/api";
import { rupiah } from "../../lib/format";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

export function Row({ label, value, bold, negative, testid }) {
  return (
    <div className={`flex items-center justify-between px-3.5 py-2.5 ${bold ? "bg-muted/60 font-bold" : ""}`} data-testid={testid}>
      <p className={`text-sm ${bold ? "font-bold" : ""}`}>{label}</p>
      <p className={`text-sm ${bold ? "font-bold" : "font-semibold"} ${negative ? "text-red-600" : ""}`}>{negative ? `(${rupiah(value)})` : rupiah(value)}</p>
    </div>
  );
}

export function PdfButton({ onClick, testid, label = "Unduh PDF" }) {
  return (
    <Button variant="outline" size="sm" onClick={onClick} data-testid={testid} className="gap-1.5 active:scale-95 transition-transform duration-100">
      <Download className="h-3.5 w-3.5" /> {label}
    </Button>
  );
}

export function PeriodeFilter({ start, end, setStart, setEnd, onApply }) {
  return (
    <div className="mt-3 flex flex-wrap items-end gap-2">
      <div>
        <p className="text-[10px] uppercase tracking-wide font-bold text-muted-foreground mb-1">Dari</p>
        <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="w-36" data-testid="filter-start" />
      </div>
      <div>
        <p className="text-[10px] uppercase tracking-wide font-bold text-muted-foreground mb-1">Sampai</p>
        <Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="w-36" data-testid="filter-end" />
      </div>
      <Button size="sm" onClick={onApply} data-testid="filter-apply" className="active:scale-95 transition-transform duration-100">Terapkan</Button>
    </div>
  );
}

export const dl = (path, name, mime) => downloadFile(path, name, mime).catch(() => toast.error("Gagal mengunduh file"));
